export default __webpack_public_path__ + "038cc796e0adc3fd54547b7ce263483f.svg";